var render = function render(){var _vm=this,_c=_vm._self._c;return _c('face-template',{attrs:{"facial-spot-locations":_vm.facialSpotLocations,"gender":_vm.gender,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }